import EmployeeClosureDetails from "./employee-closure-details";
import EmployeeClosureList from "./employee-closure-list";


function EmployeeClosure({ employeeId, employee, subpage }) {
  if(subpage) {
    return <EmployeeClosureDetails employeeId={employeeId} employee={employee} employeeClosureId={subpage} />
  } else {
    return <EmployeeClosureList employeeId={employeeId} />
  }
}

export default EmployeeClosure;